<template>
  <div class="login-form">
    <div class="card">
      <div class="title">请输入访问密钥:</div>
      <el-input
        v-model="visitKey"
        placeholder="请输入访问密钥"
        clearable
        @keyup.enter.native="handleLogin"
      ></el-input>
      <el-button type="primary" class="login-button" @click="handleLogin" :loading="loading">
        点击访问
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginSign',
  data () {
    return {
      visitKey: '',
      loading: false
    }
  },
  computed: {
    signId () {
      return this.$route.query.signId
    }
  },
  methods: {
    handleLogin () {
      if (!this.visitKey) {
        this.$message.warning('请输入访问密钥')
        return
      }

      if (!this.signId) {
        this.$message.error('缺少签到ID参数')
        return
      }

      this.loading = true
      this.$ajax({
        url: '/workspace/manager/teaching/schedule/query/clazz/loginSignQrcode',
        method: 'post',
        data: this.$qs.stringify({
          signId: this.signId,
          visitKey: this.visitKey
        })
      }).then(response => {
        if (response.data) {
          switch (response.data.responseCode) {
            case 'SUCCESS': {
              const signInfo = {
                ...response.data,
                id: this.signId,
                visitKey: this.visitKey
              }
              this.$emit('login-success', signInfo)
              break
            }
            default: {
              this.$message.warning(response.data.message || '登录失败')
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss">
.login-form {
  .card {
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 20px;

    .title {
      font-size: 16px;
      color: #303133;
      margin-bottom: 20px;
      text-align: center;
    }

    .login-button {
      width: 100%;
      margin-top: 20px;
    }
  }
}
</style>
